'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var i18nHelper = require('../../helper/i18n');
var storeHelper = require('../../helper/storeHelper');
var appTypes = require('../../types/appTypes');

var StylePicker = require('./StylePicker.jsx');
var SaveAlert = require('./SaveAlert.jsx');
var ProcessAlert = require('./ProcessAlert.jsx');
var SignCheckAlert = require('./SignCheckAlert.jsx');
var PaintToolbar = require('./PaintToolbar');

var graphicsHelper = require('../../helper/graphicsHelper');

var Mediator = require('../../helper/Review/Mediator');
var Opreations = require('../../helper/Review/PaintOpreations');
var Events = require('../../helper/Review/PaintEvents');
var LayerManager = require('../../helper/Review/LayerManager');
var Data = require('../../helper/Review/PaintData');
var Tool = require('../../helper/Review/PaintTool');
var InputText = require('../../helper/Review/InputText');
var ErrorMessage = require('../ErrorMessage');

var optimizeCall = require('../../helper/optimizeCall');
var optimizedResizeCall = optimizeCall();


var BUTTON_KEY = {
  'PENCIL': 'pencil', 'RECT': 'rect', 'ARROW': 'arrow', 'ARC': 'arc',
  'TEXT': 'text', 'MOUSE': 'mouse'
};

var CommentCover = React.createClass({

  propTypes: {
    scrollLeft: React.PropTypes.number.isRequired,
    review: React.PropTypes.array.isRequired,

    fullPageLocation: React.PropTypes.object,
    onLoadReviewData: React.PropTypes.func.isRequired,
  },

  getInitialState: function () {
    return {
      checkedKey: BUTTON_KEY.MOUSE,
    };
  },

  canvas: null,
  canvasWidth: 0,
  canvasHeight: 0,

  translateY: 0,
  translateX: 0,
  scrollTop: 0,
  scrollLeft: 0,

  adjustCanvas: function() {
    // var ctx = this.canvas.getContext('2d');
    // ctx.translate(this.translateX - this.scrollLeft, this.translateY - this.scrollTop);
    // this.translateY = this.scrollTop;
    // this.translateX = this.scrollLeft;
    Data.loadData2();
  },

  componentWillMount: function() {
    //初始化
    Mediator.init(this, Opreations, Events, LayerManager, Data, Tool, InputText);
  },

  componentDidMount: function () {
    this.canvas = ReactDOM.findDOMNode(this.refs.canvas);

    // var self = this;
    // optimizedResizeCall.add(this.adjustCanvas);
    // var documentEl;
    // if (document.documentElement) {
    //   documentEl = document.documentElement;
    // } else if (document.body) {
    //   documentEl = document.body;
    // }
    // window.onscroll = function () {
    //   self.scrollTop = documentEl.scrollTop;
    //   optimizedResizeCall.call();
    // };
    this.adjustCanvas();
  },

  componentDidUpdate: function() {
    //this.scrollLeft = this.props.scrollLeft;
    this.adjustCanvas();
    if(this.props.fullPageLocation) {
      Data.loadData2();
    }
  },

  componentWillUnmount: function() {
    Data.currentState = null;
    window.onbeforeunload = null;
    window.onScroll = null;
    optimizedResizeCall.remove(this.adjustCanvas);
  },

  render: function () {
    // var className = 'commentMode-popWindow';
    // if(document.body.clientWidth !== this.canvasWidth || document.body.clientHeight !== this.canvasHeight) {
    //   this.canvasWidth = document.body.clientWidth;
    //   this.canvasHeight = document.body.clientHeight;
    // }
    // // var w = Math.min(this.props.deviceScrollStyle.width, this.canvasWidth);
    // // var h = Math.min(this.props.deviceScrollStyle.height, this.canvasHeight - 15);
    // var w = this.props.deviceScrollStyle.width;
    // var h = this.props.deviceScrollStyle.height;
    //
    // if(this.props.deviceStyle.width < this.canvasWidth) {
    //   w = this.canvasWidth - (this.props.isShowControlPanel ? 260 : 0);
    // }

    var w = this.props.scrollContent.width;
    var h = this.props.scrollContent.height;
    var canvasStyle = {
      height: h,
      width: w,
      pointerEvents: 'none'
    };
    return (

        <canvas ref="canvas"
                width={w}
                height={h}
                style={canvasStyle}
                className="paint-stage"
        />

    )
  }
});

module.exports = CommentCover;



// WEBPACK FOOTER //
// ./src/views/Review/CommentCover.jsx